import { AxiosInstanceProvider } from '../../../../core/hooks';
import { Timespan } from '../../../chart-settings/model';
import { CpeMonitoredDevicesQuery } from '../../config';
import { MonitoredDeviceModel } from '../../model';

interface GetMonitoredDevicesPayloadModel {
  customerId: number;
  timespan: Timespan;
}

export const getMonitoredDevices = async (
  axios: AxiosInstanceProvider,
  { customerId, timespan }: GetMonitoredDevicesPayloadModel
): Promise<MonitoredDeviceModel[]> => {
  const requestConfiguration = {
    params: {
      timespan,
    }
  };
  const response = await axios().get<MonitoredDeviceModel[]>(
    CpeMonitoredDevicesQuery['GetMonitoredDevices'].url.replace('{customerId}', customerId.toString(10)),
    requestConfiguration);
  return response.data;
};